module.exports = __webpack_public_path__ + "static/img/analyzer2.a191e3bd.png";